import { render, staticRenderFns } from "./StoryPage.vue?vue&type=template&id=78d35f02&"
import script from "./StoryPage.vue?vue&type=script&lang=js&"
export * from "./StoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports